/**
 * @generated SignedSource<<3ae3abc5571ff5d7c8ce528ccdcaed27>>
 * @relayHash a3a5f17679609691298510be222cfd25
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3a5f17679609691298510be222cfd25

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Access = "APP" | "BOOK_DOC_AT_PARTNER" | "BOOK_DOC_AT_PHARMACY" | "INBOUND_CALL" | "OUTBOUND_CALL" | "PARTNER_PORTAL" | "WEBSITE" | "WEB_BOOKING";
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type AppointmentTagVariant = "ATTENTION" | "CRITICAL" | "MOST_CRITICAL" | "NEUTRAL" | "SUCCESS" | "WARNING";
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type Country = "CH" | "DE";
export type Flexibility = "FIXED_TIME" | "FLEXIBLE" | "NOT_EARLIER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MedgateConnectChannel = "PARTNER" | "PATIENT";
export type MedgateConnectOrderStatus = "CLOSED" | "FULFILLED" | "OPEN";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type PreventionProgramTreatmentPlanTemplateCase = "NO_REGION_NO_ZIP" | "REGION" | "ZIP";
export type RequestType = "NONE" | "ONBOARDING_CALL" | "PLANNED_SELF_REFERRAL" | "PRESCRIPTION" | "PRESCRIPTION_ASTHMA" | "PRESCRIPTION_ATHLETES_FOOT" | "PRESCRIPTION_BLOOD_PRESSURE" | "PRESCRIPTION_CONTRACEPTIVE_PILL" | "PRESCRIPTION_ERECTILE_DYSFUNCTION" | "PRESCRIPTION_HAY_FEVER" | "PRESCRIPTION_HEARTBURN" | "PRESCRIPTION_HYPOTHYROIDISM" | "PRESCRIPTION_MIGRAINE" | "PRESCRIPTION_URINARY_TRACT_INFECTION" | "PRESCRIPTION_VAGINAL_MYCOSIS" | "REFERRAL" | "SICK_LEAVE_CERTIFICATE" | "SICK_LEAVE_FOR_LEGAL_GUARDIAN" | "SKIN_CHECK";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type Urgency = "MEDICAL_ACUTE" | "MEDICAL_URGENT" | "NORMAL";
export type usePatientAgendaChQuery$variables = {
  language: string;
  patientId: string;
};
export type usePatientAgendaChQuery$data = {
  readonly agendaData: {
    readonly __typename: "ch_Patient";
    readonly appointments: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "Appointment";
          readonly access: Access;
          readonly appointmentType: AppointmentType;
          readonly assignedTo: string | null;
          readonly billingAttribute: {
            readonly " $fragmentSpreads": FragmentRefs<"BillingAttributeFragment">;
          } | null;
          readonly channel: CommunicationChannel;
          readonly completedAt: string | null;
          readonly date: any;
          readonly delay: number;
          readonly desiredAgentGender: Gender;
          readonly fileUploadRequest: {
            readonly " $fragmentSpreads": FragmentRefs<"FileUploadRequestFragment">;
          } | null;
          readonly flexibility: Flexibility;
          readonly followUpForProgressNote: {
            readonly id: string;
          } | null;
          readonly id: string;
          readonly isCompleted: boolean;
          readonly isInvoiced: boolean;
          readonly language: Language;
          readonly medgateConnectChannel: MedgateConnectChannel | null;
          readonly medgateConnectOrder: {
            readonly createdAt: string;
            readonly orderCode: string;
            readonly status: MedgateConnectOrderStatus;
          } | null;
          readonly partnerUserEmail: string | null;
          readonly patientAddress: {
            readonly city: string;
            readonly country: {
              readonly countryIsoCode2: string;
              readonly countryLookupTranslations: ReadonlyArray<{
                readonly countryIsoCode2: string;
                readonly countryName: string;
                readonly id: string;
                readonly language: string;
              }>;
              readonly dialCode: string;
              readonly id: string;
              readonly mask: string | null;
            } | null;
            readonly countryCode: string;
            readonly houseNumberStreet: string;
            readonly postalCode: string;
          } | null;
          readonly patientPhoneNumber: string | null;
          readonly preventionProgramKeys: ReadonlyArray<string>;
          readonly reason: string;
          readonly relatedPreventionPrograms: ReadonlyArray<{
            readonly analysis: {
              readonly matchedCase: PreventionProgramTreatmentPlanTemplateCase;
              readonly pointOfCare: PointOfCareType;
              readonly treatmentPlanTemplateId: string | null;
            };
            readonly country: Country;
            readonly id: string;
            readonly key: string;
            readonly name: {
              readonly de: string;
              readonly en: string;
            };
            readonly patientId: string;
            readonly preventionProgramId: string;
          }>;
          readonly requestType: RequestType;
          readonly service: Service;
          readonly slotId: number;
          readonly specialty: ServiceSpecialty;
          readonly startingSoonNotificationSent: boolean;
          readonly status: AppointmentStatus;
          readonly tags: ReadonlyArray<{
            readonly value: string;
            readonly variant: AppointmentTagVariant;
          }>;
          readonly takenAt: string | null;
          readonly takenBy: string | null;
          readonly updatedAt: string;
          readonly updatedBy: string;
          readonly urgency: Urgency;
        };
      }> | null;
    } | null;
    readonly ch_alternativeTriages: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "ch_AlternativeTriage";
          readonly createdAt: string;
          readonly createdBy: string;
          readonly id: string;
          readonly language: Language;
          readonly patientId: string;
          readonly phoneNumber: string;
          readonly reason: string;
          readonly timeWindowId: string | null;
        };
      }> | null;
    } | null;
    readonly externalAssistances: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "ch_ExternalAssistance";
          readonly createdAt: string;
          readonly createdBy: string;
          readonly id: string;
          readonly language: Language;
          readonly patientId: string;
          readonly phoneNumber: string;
          readonly reason: string;
        };
      }> | null;
    } | null;
    readonly timeWindows: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"chTimeWindowFragment">;
    }>;
  } | null;
};
export type usePatientAgendaChQuery = {
  response: usePatientAgendaChQuery$data;
  variables: usePatientAgendaChQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patientId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delay",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedTo",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInvoiced",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slotId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takenAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "access",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "service",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specialty",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urgency",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takenBy",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appointmentType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "desiredAgentGender",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientPhoneNumber",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startingSoonNotificationSent",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flexibility",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "patientAddress",
  "plural": false,
  "selections": [
    (v30/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CountryLookup",
      "kind": "LinkedField",
      "name": "country",
      "plural": false,
      "selections": [
        (v31/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dialCode",
          "storageKey": null
        },
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mask",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CountryLookupTranslation",
          "kind": "LinkedField",
          "name": "countryLookupTranslations",
          "plural": true,
          "selections": [
            (v31/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "countryName",
              "storageKey": null
            },
            (v4/*:: as any*/),
            (v15/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "houseNumberStreet",
      "storageKey": null
    },
    (v32/*:: as any*/),
    (v33/*:: as any*/)
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medgateConnectChannel",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnerUserEmail",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderCode",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "AppointmentTag",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "variant",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preventionProgramKeys",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preventionProgramId",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "LocalizedName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "en",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "de",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "PreventionProgramAnalysis",
  "kind": "LinkedField",
  "name": "analysis",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchedCase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pointOfCare",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "treatmentPlanTemplateId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v52 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Ch_alternativeTriagesEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_AlternativeTriage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v38/*:: as any*/),
          (v50/*:: as any*/),
          (v4/*:: as any*/),
          (v15/*:: as any*/),
          (v42/*:: as any*/),
          (v51/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeWindowId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v47/*:: as any*/)
    ],
    "storageKey": null
  },
  (v48/*:: as any*/)
],
v53 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ch_ExternalAssistanceEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_ExternalAssistance",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v38/*:: as any*/),
          (v50/*:: as any*/),
          (v4/*:: as any*/),
          (v15/*:: as any*/),
          (v42/*:: as any*/),
          (v51/*:: as any*/),
          (v8/*:: as any*/)
        ],
        "storageKey": null
      },
      (v47/*:: as any*/)
    ],
    "storageKey": null
  },
  (v48/*:: as any*/)
],
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v58 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePatientAgendaChQuery",
    "selections": [
      {
        "alias": "agendaData",
        "args": (v2/*:: as any*/),
        "concreteType": "ch_Patient",
        "kind": "LinkedField",
        "name": "ch_patientById",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": "appointments",
            "args": null,
            "concreteType": "AppointmentConnection",
            "kind": "LinkedField",
            "name": "__patientIdConnection_appointments_connection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppointmentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v4/*:: as any*/),
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v9/*:: as any*/),
                      (v10/*:: as any*/),
                      (v11/*:: as any*/),
                      (v12/*:: as any*/),
                      (v13/*:: as any*/),
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/),
                      (v18/*:: as any*/),
                      (v19/*:: as any*/),
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      (v24/*:: as any*/),
                      (v25/*:: as any*/),
                      (v26/*:: as any*/),
                      (v27/*:: as any*/),
                      (v28/*:: as any*/),
                      (v29/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingAttribute",
                        "kind": "LinkedField",
                        "name": "billingAttribute",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "BillingAttributeFragment"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "followUpForProgressNote",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v34/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FileUploadRequest",
                        "kind": "LinkedField",
                        "name": "fileUploadRequest",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "FileUploadRequestFragment"
                          }
                        ],
                        "storageKey": null
                      },
                      (v35/*:: as any*/),
                      (v36/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MedgateConnectOrder",
                        "kind": "LinkedField",
                        "name": "medgateConnectOrder",
                        "plural": false,
                        "selections": [
                          (v37/*:: as any*/),
                          (v9/*:: as any*/),
                          (v38/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v39/*:: as any*/),
                      (v40/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "relatedPreventionPrograms",
                        "plural": true,
                        "selections": [
                          (v41/*:: as any*/),
                          (v42/*:: as any*/),
                          (v4/*:: as any*/),
                          (v43/*:: as any*/),
                          (v44/*:: as any*/),
                          (v45/*:: as any*/),
                          (v46/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v47/*:: as any*/)
                ],
                "storageKey": null
              },
              (v48/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_TimeWindow",
            "kind": "LinkedField",
            "name": "timeWindows",
            "plural": true,
            "selections": [
              {
                "args": (v49/*:: as any*/),
                "kind": "FragmentSpread",
                "name": "chTimeWindowFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "ch_alternativeTriages",
            "args": null,
            "concreteType": "Ch_alternativeTriagesConnection",
            "kind": "LinkedField",
            "name": "__PatientByIdConnection_ch_alternativeTriages_connection",
            "plural": false,
            "selections": (v52/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "externalAssistances",
            "args": null,
            "concreteType": "ch_ExternalAssistanceConnection",
            "kind": "LinkedField",
            "name": "__PatientByIdConnection_externalAssistances_connection",
            "plural": false,
            "selections": (v53/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "usePatientAgendaChQuery",
    "selections": [
      {
        "alias": "agendaData",
        "args": (v2/*:: as any*/),
        "concreteType": "ch_Patient",
        "kind": "LinkedField",
        "name": "ch_patientById",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppointmentConnection",
            "kind": "LinkedField",
            "name": "appointments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppointmentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v4/*:: as any*/),
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      (v8/*:: as any*/),
                      (v9/*:: as any*/),
                      (v10/*:: as any*/),
                      (v11/*:: as any*/),
                      (v12/*:: as any*/),
                      (v13/*:: as any*/),
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/),
                      (v18/*:: as any*/),
                      (v19/*:: as any*/),
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      (v24/*:: as any*/),
                      (v25/*:: as any*/),
                      (v26/*:: as any*/),
                      (v27/*:: as any*/),
                      (v28/*:: as any*/),
                      (v29/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingAttribute",
                        "kind": "LinkedField",
                        "name": "billingAttribute",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isNotBillable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notBillableReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "treatmentReason",
                            "storageKey": null
                          },
                          (v8/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isVisualSymptomExamination",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentGestationWeek",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "organisationId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dateOfAccident",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accidentReference",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isEmployer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lawType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ivgCaseReference",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mvgCaseReference",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "followUpForProgressNote",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v34/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FileUploadRequest",
                        "kind": "LinkedField",
                        "name": "fileUploadRequest",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          (v38/*:: as any*/),
                          (v50/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sessionCode",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v35/*:: as any*/),
                      (v36/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MedgateConnectOrder",
                        "kind": "LinkedField",
                        "name": "medgateConnectOrder",
                        "plural": false,
                        "selections": [
                          (v37/*:: as any*/),
                          (v9/*:: as any*/),
                          (v38/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v39/*:: as any*/),
                      (v40/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "relatedPreventionPrograms",
                        "plural": true,
                        "selections": [
                          (v3/*:: as any*/),
                          (v41/*:: as any*/),
                          (v42/*:: as any*/),
                          (v4/*:: as any*/),
                          (v43/*:: as any*/),
                          (v44/*:: as any*/),
                          (v45/*:: as any*/),
                          (v46/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v47/*:: as any*/)
                ],
                "storageKey": null
              },
              (v48/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "patientIdConnection_appointments",
            "kind": "LinkedHandle",
            "name": "appointments"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_TimeWindow",
            "kind": "LinkedField",
            "name": "timeWindows",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v50/*:: as any*/),
              (v38/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "errorCorrection",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "referenceDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "referredByExternalCareProviderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alternativeTriage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "referralReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProvider",
                "kind": "LinkedField",
                "name": "referralToCareProvider",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v54/*:: as any*/),
                  (v55/*:: as any*/),
                  (v56/*:: as any*/),
                  (v57/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v49/*:: as any*/),
                    "kind": "ScalarField",
                    "name": "groupName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v49/*:: as any*/),
                    "concreteType": "SpecialtyTranslation",
                    "kind": "LinkedField",
                    "name": "careProviderSpecialtyTranslations",
                    "plural": true,
                    "selections": (v58/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v49/*:: as any*/),
                    "concreteType": "OfficialLanguageLookupTranslation",
                    "kind": "LinkedField",
                    "name": "officialLanguageLookupTranslations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoLanguageName",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CareProviderGroup",
                    "kind": "LinkedField",
                    "name": "careProviderGroup",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "groupType",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CountryLookup",
                    "kind": "LinkedField",
                    "name": "country",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v49/*:: as any*/),
                        "kind": "ScalarField",
                        "name": "countryName",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "creditorCodeRegister",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMedgatePartnerNetworkMember",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTakesNewPatients",
                    "storageKey": null
                  },
                  (v51/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "website",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "globalLocationNumber",
                    "storageKey": null
                  },
                  (v33/*:: as any*/),
                  (v30/*:: as any*/),
                  (v32/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "streetAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "additionalAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationBusinessName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationFirstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationLastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CareProvider",
                    "kind": "LinkedField",
                    "name": "billsVia",
                    "plural": false,
                    "selections": [
                      (v54/*:: as any*/),
                      (v56/*:: as any*/),
                      (v57/*:: as any*/),
                      (v55/*:: as any*/),
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_Network",
                    "kind": "LinkedField",
                    "name": "network",
                    "plural": false,
                    "selections": (v58/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DaySchedule",
                    "kind": "LinkedField",
                    "name": "detailedSchedule",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "day",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "workingType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimePeriod",
                        "kind": "LinkedField",
                        "name": "periods",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "start",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "end",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateFrom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dateTo",
                "storageKey": null
              },
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internalComment",
                "storageKey": null
              },
              (v42/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "referralToCareProviderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "referralToDoctorName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "referredBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "progressNoteId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "involvesPreventionProgram",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_AlternativeTriage",
                "kind": "LinkedField",
                "name": "alternativeTriageEntry",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v51/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Ch_alternativeTriagesConnection",
            "kind": "LinkedField",
            "name": "ch_alternativeTriages",
            "plural": false,
            "selections": (v52/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "PatientByIdConnection_ch_alternativeTriages",
            "kind": "LinkedHandle",
            "name": "ch_alternativeTriages"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ExternalAssistanceConnection",
            "kind": "LinkedField",
            "name": "externalAssistances",
            "plural": false,
            "selections": (v53/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "connection",
            "key": "PatientByIdConnection_externalAssistances",
            "kind": "LinkedHandle",
            "name": "externalAssistances"
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a3a5f17679609691298510be222cfd25",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "agendaData",
            "appointments"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "agendaData",
            "ch_alternativeTriages"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "agendaData",
            "externalAssistances"
          ]
        }
      ]
    },
    "name": "usePatientAgendaChQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "32cfa57529c9cbc5bb3a92e51896708f";

export default node;
